import React, { useState } from "react";
import { CameraOutlined } from "@ant-design/icons";
import { Button, Tooltip, notification } from "antd";
import { takeScreenshot } from "../../services/devicemanagementservice";

interface ScreenshotButtonProps {
    deviceId: string;
    aliasName?: string;
    onScreenshotTaken?: () => void;
}

const ScreenshotButton: React.FC<ScreenshotButtonProps> = ({
    deviceId,
    aliasName,
    onScreenshotTaken,
}) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true);
        try {
            const { data } = await takeScreenshot(deviceId);
            if (data.success) {
                notification.success({
                    message: "Screenshot Captured",
                    description: aliasName
                        ? `A screenshot has been captured from device "${aliasName}".`
                        : "A screenshot has been captured successfully.",
                    placement: "topRight",
                });
                if (onScreenshotTaken) {
                    onScreenshotTaken();
                }
            } else {
                notification.error({
                    message: "Screenshot Failed",
                    description: aliasName
                        ? `We couldn’t capture a screenshot from device "${aliasName}". Please try again later.`
                        : "We couldn’t capture a screenshot. Please try again later.",
                    placement: "topRight",
                });
            }
        } catch {
            notification.error({
                message: "Unexpected Error",
                description: aliasName
                    ? `An error occurred while sending the screenshot command to "${aliasName}".`
                    : "An error occurred while sending the screenshot command.",
                placement: "topRight",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip title="Take Screenshot">
            <Button
                icon={<CameraOutlined style={{ color: "var(--color-primary)" }} />}
                loading={loading}
                disabled={loading}
                onClick={handleClick}
            />
        </Tooltip>
    );
};

export default ScreenshotButton;